import { useEffect } from 'react'
import type { ContactInquiryCounts } from '@fiket/shared'
import { useApiFetch } from '@/hooks/useApiFetch'
import { INQUIRY_COUNTS_EVENT } from '../pages/inquiries/types'

/** 사이드바 "고객 문의" 옆 미답변 수. 0 이면 렌더하지 않음. 답변/상태 변경 이벤트에 재조회. */
export function InquiryNavBadge() {
  const { data, refetch } = useApiFetch<ContactInquiryCounts>('/api/admin/contact-inquiries/counts', {
    revalidateOnFocus: true,
  })

  useEffect(() => {
    const handler = () => refetch()
    window.addEventListener(INQUIRY_COUNTS_EVENT, handler)
    return () => window.removeEventListener(INQUIRY_COUNTS_EVENT, handler)
  }, [refetch])

  const n = data?.needsReply ?? 0
  if (n <= 0) return null
  return (
    <span
      className="ml-auto rounded-full bg-[#c4443f] px-1.5 py-px text-[0.6875rem] font-bold leading-4 text-white"
      aria-label={`미답변 문의 ${n}건`}
    >
      {n > 99 ? '99+' : n}
    </span>
  )
}
